export default function TrustStrip() {
  const items = [
    'Legal Services',
    'Medical Practices',
    'Financial Advisory',
    'Real Estate Firms',
    'Professional Services',
    'Accounting Firms'
  ];

  return (
    <section className="bg-[#1A2B45] py-8 overflow-hidden relative">
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#1A2B45] to-transparent z-10"></div>
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#1A2B45] to-transparent z-10"></div>
      
      <div className="flex items-center gap-12 animate-scroll whitespace-nowrap">
        {[...items, ...items, ...items].map((item, index) => (
          <div key={index} className="flex items-center gap-12">
            <div className="px-6 py-2 rounded-full border border-white/20 bg-white/5">
              <span className="text-white/80 text-sm font-medium">{item}</span>
            </div>
            <span className="text-white/40 text-sm">•</span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
      `}</style>
    </section>
  );
}
